import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import {
  ApBaseClass,
  ColumnFieldType,
  ColumnInfoDto,
  ColumnItemDto,
  IColumnPk,
  TableConfigGroup,
} from 'webcommon/shared';

@Component({
  selector: 'ap-configurable-table',
  templateUrl: './ap-configurable-table.component.html',
})
export class ApConfigurableTableComponent extends ApBaseClass implements OnInit, OnChanges {
  // TODO look into passing a param object?
  @Input() baseId: string; // Unique Id of current tile
  @Input() tableId: string; // Name of table in current tile
  @Input() clientColumnInfoList: Array<ColumnInfoDto<any>>; // any has to be an enum
  @Input() serverColumnItemList: Array<ColumnItemDto<any>>; // any has to be an enum
  @Input() dataItemList: IColumnPk[];
  @Input() setStickyHeaders = false;
  @Input() set groupBy(val: any) {
      this._groupBy = val;
      this.mainDataItmLst = this.getListToDisplay();
  }

  columnInfoListToShow: Array<ColumnInfoDto<any>>;
  Id: string;
  mainDataItmLst: any[] = [];
  private _groupBy = '';

  ngOnInit() {
    this.setId();
    this.setColumnInfoListToShow();
    this.mainDataItmLst = this.getListToDisplay();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.baseId || changes.tableId) {
      this.setId();
    }
    if (changes.clientColumnInfoList || changes.serverColumnItemList) {
      this.setColumnInfoListToShow();
    }
    if (changes.dataItemList)
    {
      this.mainDataItmLst = this.getListToDisplay();
    }
  }

  private setId() {
    this.Id = `tile-${this.baseId}-table-${this.tableId}`;
  }

  private setColumnInfoListToShow() {
    this.columnInfoListToShow = new Array<ColumnInfoDto<any>>();

    // The server items will be in the order the columns should show up in
    this.serverColumnItemList.forEach((serverItem) => {
      const itemInfo = this.getColumnInfoToAdd(serverItem);
      if (itemInfo) {
        this.columnInfoListToShow.push(itemInfo);
      }
    });
  }

  private getColumnInfoToAdd(serverItem: ColumnItemDto<any>) {
    // Seperating this method in case the server sends more info in the future so we have to map it
    return this.clientColumnInfoList.find((clientInfo) => {
      return clientInfo.ColumnName === serverItem.ColumnName;
    });
  }

  get ColumnFieldTypes() {
    return ColumnFieldType;
  }

  private getListToDisplay(): any {
    let ItemLst: any[] = [];
    if (this._groupBy.length > 0) {
      try {
        const lst: any[] = [...this.dataItemList];
        const distinctGroupName = lst.filter((obj, index, arr) =>
                              arr.findIndex(item => item[this._groupBy as any] === obj[this._groupBy as any]) === index);
        ItemLst = distinctGroupName.map((groupName) => {
          return  new TableConfigGroup(groupName[this._groupBy as any], this.grouping(groupName[this._groupBy as any])) ;
        });
        return ItemLst;
      }
      catch (e) {
        console.warn(e);
      }
    }
    else {
      ItemLst.push(new TableConfigGroup('', this.dataItemList));
      return ItemLst;
    }
  }

  private grouping(filterby: string): any[] {
    const lst: any[] = [...this.dataItemList];
    return lst.filter(f => f[this._groupBy as any] === filterby);
  }
}
